import { Row, Col, Typography, Button, Space, Divider, message } from "antd";
import { MdLockOutline, MdAccountBox, MdEmail, MdPhone } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";
const { Title, Text } = Typography;
export default function ContactDetails({
  unlock,
  contactData,
  loadingContactData,
}) {
  return (
    <>
      {/* <Row>
        <Col span={24}>
          <Title level={5}> Contact Details</Title>
        </Col>
      </Row> */}
      {contactData ? (
        <UnLockedState contactData={contactData} />
      ) : (
        <LockedState unlock={unlock} loadingContactData={loadingContactData} />
      )}
    </>
  );
}

const LockedState = ({ unlock, loadingContactData }) => {
  return (
    <Row justify="center" align="middle" className="contact-details">
      <Col>
        <Row justify="center">
          <MdLockOutline
            style={{
              fontSize: "7em",
              background: "rgba(29, 38, 36, 0.5)",
              padding: 10,
              borderRadius: "50%",
              color: "white",
            }}
          />
        </Row>
        <Row justify="center" style={{ marginTop: "1.5em" }}>
          <Button
            style={{ background: "black", color: "white", border: 0 }}
            size="large"
            onClick={() => unlock()}
            loading={loadingContactData}
          >
            Unlock Prospect
          </Button>
        </Row>
      </Col>
    </Row>
  );
};

const UnLockedState = ({ contactData }) => {
  const copyText = async (text) => {
    await navigator.clipboard.writeText(text);
    message.success("Copied to clipboard");
  };
  return (
    <>
      {" "}
      {contactData?.length > 0 ? (
        <Row>
          <Col
            span={24}
            className="contact-details"
            style={{ padding: "1.5em" }}
          >
            <Row>
              <Col>
                <Space>
                  <MdAccountBox size={24} color="#14453C" />{" "}
                  <Title level={5}>
                    {" "}
                   Contact details
                  </Title>
                </Space>
              </Col>
            </Row>
            <Divider />

            {contactData?.[0]?.contact_provider.map((contact, index) => (
              <Row key={index}>
                <Col span={24}>
                  <Row>
                    <Title level={5}>
                      {contact?.first_name} {contact?.last_name}
                    </Title>
                  </Row>
                  <Row>
                    <Text>{contact?.designation}</Text>
                  </Row>

                  {/* Linkedin */}
                  {contact?.url && (
                    <Row
                      justify="space-between"
                      align="top"
                      style={{ marginTop: "1.5em" }}
                    >
                      <Col span={6}>
                        <Space>
                          <FaLinkedinIn size={24} color="#B4B7B6" />
                          <Text ellipsis>Linkedin</Text>
                        </Space>
                      </Col>

                      <Col offset={2} span={16}>
                        <Row>
                          <Text ellipsis>{contact?.url}</Text>
                        </Row>
                        <Row>
                          <Button
                            style={{ padding: 0 }}
                            type="link"
                            onClick={() => copyText(contact?.url)}
                          >
                            Copy link
                          </Button>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {/* email */}
                  {contact?.email && contact?.email.trim() && (
                    <Row
                      justify="space-between"
                      align="top"
                      style={{ marginTop: "1.5em" }}
                    >
                      <Col span={6}>
                        <Space>
                          <MdEmail size={24} color="#B4B7B6" />
                          <Text ellipsis>Email</Text>
                        </Space>
                      </Col>

                      <Col offset={2} span={16}>
                        <Row>
                          <Text ellipsis>{contact?.email}</Text>
                        </Row>
                        <Row>
                          <Button
                            style={{ padding: 0 }}
                            type="link"
                            onClick={() => copyText(contact?.email)}
                          >
                            Copy link
                          </Button>
                        </Row>
                      </Col>
                    </Row>
                  )}
                  {/* phone */}
                  {contact?.contact_number && (
                    <Row
                      justify="space-between"
                      align="top"
                      style={{ marginTop: "1.5em" }}
                    >
                      <Col span={6}>
                        <Space>
                          <MdPhone size={24} color="#B4B7B6" />
                          <Text ellipsis>Phone</Text>
                        </Space>
                      </Col>

                      <Col offset={2} span={16}>
                        <Row>
                          <Text ellipsis>{contact?.contact_number}</Text>
                        </Row>
                      </Col>
                    </Row>
                  )}
                </Col>
                {index !== contactData?.[0]?.contact_provider.length - 1 && (
                  <Divider />
                )}
              </Row>
            ))}
          </Col>
        </Row>
      ) : (
        <Row
          justify="center"
          align="middle"
          className="contact-details"
          style={{ padding: "1.5em" }}
        >
          <Col>
            <Row justify="center">
              <Col>
                <Row justify="center">
                  <MdAccountBox size={50} color="#9B9F9E" />
                </Row>
                <Row justify="center">
                  <Title level={4}>Request for contact details sent</Title>
                </Row>
                <Row justify="center">
                  <span type="secondary" style={{ textAlign: "center" }}>
                    We are searching contact details for this buyer. Our team
                    will notify on email once found.
                  </span>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};
